import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetListSummaryQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type GetListSummaryQuery = {
  __typename?: 'Query';
  list?: {
    __typename?: 'List';
    id: any;
    name: string;
    isSystem: boolean;
  } | null;
};

export const GetListSummaryDocument = gql`
  query GetListSummary($id: UUID!) {
    list(id: $id) {
      id
      name
      isSystem
    }
  }
`;

/**
 * __useGetListSummaryQuery__
 *
 * To run a query within a React component, call `useGetListSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetListSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetListSummaryQuery,
    GetListSummaryQueryVariables
  > &
    (
      | { variables: GetListSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetListSummaryQuery, GetListSummaryQueryVariables>(
    GetListSummaryDocument,
    options,
  );
}
export function useGetListSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListSummaryQuery,
    GetListSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetListSummaryQuery, GetListSummaryQueryVariables>(
    GetListSummaryDocument,
    options,
  );
}
export function useGetListSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetListSummaryQuery,
        GetListSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetListSummaryQuery,
    GetListSummaryQueryVariables
  >(GetListSummaryDocument, options);
}
export type GetListSummaryQueryHookResult = ReturnType<
  typeof useGetListSummaryQuery
>;
export type GetListSummaryLazyQueryHookResult = ReturnType<
  typeof useGetListSummaryLazyQuery
>;
export type GetListSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetListSummarySuspenseQuery
>;
export type GetListSummaryQueryResult = Apollo.QueryResult<
  GetListSummaryQuery,
  GetListSummaryQueryVariables
>;
